import API from "../../api/mercadopago";
import { throwErrorMessage } from "../utils/api";

const state = {
  recordsByConversation: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

const getters = {
  getByConversation: (s) => (conversationId) =>
    s.recordsByConversation[conversationId] || [],
  uiFlags: (s) => s.uiFlags,
};

const actions = {
  async fetchByConversation({ commit }, conversationId) {
    commit("SET_UI_FLAG", { isFetching: true });
    try {
      const { data } = await API.getByConversation(conversationId);
      commit("SET_RECORDS", {
        conversationId,
        records: Array.isArray(data) ? data : [],
      });
    } catch {
      // swallow: UI shows empty state on fetch failure
    } finally {
      commit("SET_UI_FLAG", { isFetching: false });
    }
  },

  async createPaymentLink({ commit }, paymentData) {
    commit("SET_UI_FLAG", { isCreating: true });
    try {
      const { data } = await API.createLink(paymentData);
      commit("ADD_RECORD", {
        conversationId: paymentData.conversationId,
        record: data,
      });
      return data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit("SET_UI_FLAG", { isCreating: false });
    }
  },
};

const mutations = {
  SET_RECORDS: (s, { conversationId, records }) => {
    s.recordsByConversation[conversationId] = records;
  },
  ADD_RECORD: (s, { conversationId, record }) => {
    if (!s.recordsByConversation[conversationId]) {
      s.recordsByConversation[conversationId] = [];
    }
    s.recordsByConversation[conversationId].unshift(record);
  },
  SET_UI_FLAG: (s, flags) => {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
};

export default { namespaced: true, state, getters, actions, mutations };
